<template>
  <div class="sirui-upload">
    <!--上传excel-->
    <el-dialog
      :title="$t('import.importTitle')"
      :visible.sync="dialogUpload"
      :close-on-click-modal="false"
      append-to-body
      width="450px"
    >
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="importUrl"
        :data="data"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-error="handleUploadError"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
      >
        <el-button slot="trigger" size="small">{{ this.$t('import.chooseFile') }}</el-button>
        <el-button
          style="margin-left: 10px"
          size="small"
          type="primary"
          :loading="loading"
          @click="submitUpload"
          >{{ this.$t('import.submitImport') }}</el-button
        >
        <el-button v-if="isShowDownTemplateBtn" type="primary" @click="downTemplate(fileKey)"
          >下载模板</el-button
        >
        <div slot="tip" class="el-upload__tip">{{ this.$t('import.importTips') }}</div>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
  import baseUrl from '@/common/config';
  import API from '@/api/property/meterManagement';
  export default {
    name: 'MeterUpload',
    data() {
      return {
        dialogUpload: false,
        fileList: [],
        loading: false,
        fileKey: '',
        idList: [],
        exchangeRate: 1,
      };
    },
    props: {
      source: {
        type: String,
        default: () => '',
      },
      //请求地址
      action: {
        type: String,
        default: () => '',
      },
      //额外参数
      data: {
        type: Object,
        default: () => {},
      },
      // 是否显示下载模板按钮
      isShowDownTemplateBtn: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      importUrl() {
        return baseUrl + this.action;
      },
    },
    mounted() {},
    methods: {
      openDialog(flag, fileKey = '', idList, exchangeRate) {
        this.dialogUpload = flag;
        this.fileKey = fileKey;
        this.idList = idList;
        this.fileList = [];
        this.exchangeRate = exchangeRate;
      },
      beforeUpload(file) {
        if (this.fileKey == 'KPMB') {
          this.data.receivableSettlementLineIds = this.idList;
          this.data.exchangeRate = this.exchangeRate;
        }
        this.loading = true;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls';
        const extension2 = testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!extension && !extension2) {
          this.loading = false;
          this.$message({
            message: this.$t('import.importType'),
            type: 'error',
          });
        }
        if (!isLt2M) {
          this.loading = false;
          this.$message({
            message: this.$t('import.importLimit'),
            type: 'error',
          });
        }
        return extension || (extension2 && isLt2M);
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed() {
        this.$message({
          message: this.$t('upload.error'),
          type: 'error',
        });
      },
      handleSuccess(res, file, fileList) {
        // debugger;
        this.loading = false;
        if (this.source === 'order') {
          if (res.code === 0) {
            this.dialogUpload = false;
            this.$message({
              message: res.msg,
              type: 'success',
            });
            if (this.$listeners['ossSuccess']) this.$emit('ossSuccess', res, file, fileList);
          }
        } else {
          if (0 == res.code) {
            this.dialogUpload = false;
            if (res.msg && res.data && this.fileKey != 'KPMB') {
              this.$alert(res.msg);
              window.location.href = `${res.data}`;
            } else {
              this.$message({
                message: this.$t('import.importSuccess'),
                type: 'success',
              });
              //返回成功回调
              if (this.$listeners['ossSuccess']) this.$emit('ossSuccess', res.data, file, fileList);
            }
            //刷新列表
            if (!this.$listeners['ossSuccess']) this.$emit('getData');
          } else {
            // this.$alert(res.msg);
            this.$message({
              message: res.msg || '操作失败',
              type: 'error',
            });
            if (res.data) {
              window.location.href = `${res.data}`;
            }
          }
        }

        this.fileList = [];
      },
      handleUploadError() {
        this.loading = false;
        console.log('文件上传失败');
      },
      async downTemplate(fileKey) {
        if (!fileKey) {
          this.$message.error('请传递模板');
          return;
        }
        let params = {
          companyCode: this.userInfo.companyCode,
          template: true,
        };
        if (fileKey == '08') {
          const { data } = await this.$axios.post(API.READ_PAGE_EXPORT, params);
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('模板下载成功');
          } else {
            this.$message.error('模板下载失败');
          }
        } else if (fileKey == '010') {
          const { data } = await this.$axios.post(API.WATER_METER_READ_EXPORT, params);
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('模板下载成功');
          } else {
            this.$message.error('模板下载失败');
          }
        } else if (fileKey == 'KPMB') {
          const { data } = await this.$axios.post(
            '/financial/financeSalesInvoice/exportSettleLine',
            this.idList
          );
          if (data.code === 0) {
            window.location.href = data.data.data.word;
            this.$message.success('模板下载成功');
          } else {
            this.$message.error('模板下载失败');
          }
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;
  .upload-demo {
    height: 150px;
  }
  .el-button {
    border: 1px solid $maintheme;
    color: $maintheme;
  }
  .el-button--primary {
    color: #fff;
    background-color: $maintheme;
    border-color: $maintheme;
  }
</style>
